import { render, staticRenderFns } from "./ModifyComparisonModal.vue?vue&type=template&id=5bfedcb1&"
import script from "./ModifyComparisonModal.vue?vue&type=script&lang=ts&"
export * from "./ModifyComparisonModal.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports